<ng-template #pageTitle>
  <h5 class="text-neutral-900 font-semibold text-2xl ps-2xl">
    {{ 'account_settings_screen_title' | transloco }}
  </h5>
</ng-template>

<div [class]="systemTabsPageClasses()">
  @if (!floating()) {
    <div class="mb-2xl">
      <ng-container [ngTemplateOutlet]="pageTitle" />
    </div>
  }

  <lib-tabs
    [tabSegmented]="systemTabs()"
    [tabsStartRef]="floating() ? pageTitle : null"
    [tabsHeaderClass]="floating() ? 'mb-lg' : ''"
    [tabPill]="!systemTabs()"
    [tabsBorder]="!systemTabs()"
    [tabsClass]="systemTabs() ? '' : 'border-neutral-200 pb-2xl !text-sm'"
    [enableTabRouting]="true">
    <lib-tab
      [tabRoutingParam]="'profile'"
      [tabTitle]="'account_settings_screen_profile_tab_label' | transloco"
      #profileTab>
      @if (profileTab.active()) {
        <lib-profile-tab [class]="tabPanelClasses()" />
      }
    </lib-tab>

    <lib-tab
      [tabRoutingParam]="'security'"
      [tabTitle]="'account_settings_screen_security_tab_label' | transloco"
      #securityTab>
      @if (securityTab.active()) {
        <lib-security-tab [class]="tabPanelClasses()" />
      }
    </lib-tab>

    <lib-tab
      [tabRoutingParam]="'notifications'"
      [tabTitle]="'account_settings_screen_notification_tab_label' | transloco"
      #notificationTab>
      @if (notificationTab.active()) {
        <lib-notification-tab
          [class]="floating() ? 'block floating-card' : ''" />
      }
    </lib-tab>

    @if (isDelegationTabEnabled()) {
      <lib-tab
        [tabRoutingParam]="'delegation'"
        [tabTitle]="'account_settings_screen_delegation_tab_label' | transloco"
        #delegationTab>
        @if (delegationTab.active()) {
          <lib-delegation-tab />
        }
      </lib-tab>
    }

    @for (appTab of appTabs; track appTab.routingParam) {
      <lib-tab
        [tabRoutingParam]="appTab.routingParam"
        [tabTitle]="appTab.titleKey | transloco"
        #extraTab>
        @if (extraTab.active()) {
          <ng-container *ngComponentOutlet="appTab.component" />
        }
      </lib-tab>
    }
  </lib-tabs>
</div>
